export singleton from './singleton'
export unique from './unique'



/** WEBPACK FOOTER **
 ** ./src/components/validators/index.js
 **/